import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.25 8.87109H8.75V10.1836H12.25C12.4688 10.1836 12.6875 10.4023 12.6875 10.6211V12.8086C12.6875 13.0547 12.4688 13.2461 12.25 13.2461H1.75C1.50391 13.2461 1.3125 13.0547 1.3125 12.8086V10.6211C1.3125 10.4023 1.50391 10.1836 1.75 10.1836H5.25V8.87109H1.75C0.765625 8.87109 0 9.66406 0 10.6211V12.8086C0 13.793 0.765625 14.5586 1.75 14.5586H12.25C13.207 14.5586 14 13.793 14 12.8086V10.6211C14 9.66406 13.207 8.87109 12.25 8.87109ZM3.71875 5.39844L6.34375 2.80078V10.1836C6.34375 10.5664 6.61719 10.8398 7 10.8398C7.35547 10.8398 7.65625 10.5664 7.65625 10.1836V2.80078L10.2539 5.39844C10.3633 5.53516 10.5273 5.58984 10.7188 5.58984C10.8828 5.58984 11.0469 5.53516 11.1562 5.39844C11.4297 5.15234 11.4297 4.74219 11.1562 4.46875L7.4375 0.75C7.19141 0.503906 6.78125 0.503906 6.53516 0.75L2.81641 4.46875C2.54297 4.74219 2.54297 5.15234 2.81641 5.39844C3.0625 5.67188 3.47266 5.67188 3.71875 5.39844ZM11.8125 11.7148C11.8125 11.3594 11.5117 11.0586 11.1562 11.0586C10.7734 11.0586 10.5 11.3594 10.5 11.7148C10.5 12.0977 10.7734 12.3711 11.1562 12.3711C11.5117 12.3711 11.8125 12.0977 11.8125 11.7148Z",
		fill: "#616161"
	})]
});
const ForwardRef = forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
